<template>
  <v-card id="consignee" class="mt-4">
    <v-card-title class="primary h5 text-white">{{
      $t(item.title)
    }}</v-card-title>
    <v-card-text style="font-size: 16px">
      <v-row class="my-4">
        <v-simple-table class="table-compact">
          <template v-slot:default>
            <tbody class="border-0 w-100">
              <tr v-for="(element, index) in item.data" :key="index">
                <td class="px-3 py-0 h-30px">
                  <span class="other_key font-size-lg"
                    >{{ $t(element.title) }}:
                  </span>
                </td>
                <v-btn
                  v-if="
                    element.title == 'consignee_document_link' && element.value
                  "
                  elevation="0"
                  @click="showConsigneeDetails(element.value)"
                  >{{ $t("view_document_details") }}</v-btn
                >
                <td v-else class="px-3 py-0 h-30px">
                  <span
                    class="other_value font-weight-bold font-size-base"
                    :style="element.style"
                    >{{ element.value ?? "-" }}</span
                  >
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "PopUpTextGroup",
  props: ["item"],
  methods: {
    showConsigneeDetails(url) {
      const link = document.createElement("a");
      link.href = url;
      link.target = "_blank";
      link.download = "orders.csv";
      link.click();
    },
  },
};
</script>
